













































import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import wait from '@/plugins/tegaki/wait'
import TegakiCanvas from '@/components/tegaki/TegakiCanvas.vue'
import MyScript, { MyScriptStroke } from './MyScript/'
import katex from 'katex'

export type Stroke = {
  x: number
  y: number
}

@Component({
  components: {
    TegakiCanvas,
  },
})
export default class Tegaki extends Vue {
  private katexPosition: {
    left: number | string
    top: number | string
    width: number | string
    color: string
  } = {
    left: 0,
    top: 0,
    width: 0,
    color: 'rgba(0, 0, 0, 0.6)',
  }
  private textPosition: {
    height: number | string
  } = {
    height: 0,
  }
  private textObserver: any
  private katexObserver: any

  @Ref() textfield!: HTMLInputElement
  @Ref() katexfield!: HTMLElement
  @Ref() canvas!: TegakiCanvas

  @Prop()
  value!: string | null

  @Prop()
  lang!: string

  @Prop()
  savedStrokes?: Stroke[][]

  @Prop({ default: false })
  canStandardKeydoard?: boolean

  private innerWidth = 0
  private innerHeight = 0
  private mode = 'pen'
  private resultHtml = ''
  private resultLatex = ''
  private strokes: Stroke[][] = []
  private isShow = false
  private myScript = new MyScript({ lang: this.lang })

  get width(): number {
    return Math.round(this.innerWidth * 0.9)
  }
  get height(): number {
    return Math.round(this.innerHeight * 0.3)
  }
  get tegakiStyle(): { [key: string]: string } {
    return {
      '--tegaki-display': this.isShow ? 'block' : 'none',
      '--tegaki-canvas-width': `${this.width}px`,
      '--tegaki-canvas-height': `${this.height}px`,
    }
  }
  get displayResult(): string {
    return this.lang === 'MATHML' ? this.value && katex.renderToString(this.value) : this.value
  }

  private beforeMount() {
    if (this.value) {
      this.resultLatex = this.value
      this.resultHtml = katex.renderToString(this.value)
    }
    if (this.savedStrokes) this.strokes = this.savedStrokes
  }
  private mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()

    this.textObserver = new (window as any).ResizeObserver(() => {
      this.katexPosition = {
        width: `${this.textfield.offsetWidth - 4}px`,
        left: `${this.textfield.offsetLeft + 2}px`,
        top: `${this.textfield.offsetTop + 2}px`,
        color: 'rgb(0, 0, 0)',
      }
    })
    this.textObserver.observe(this.textfield)

    this.katexObserver = new (window as any).ResizeObserver(() => {
      this.textPosition = {
        height: `${(this.katexfield.offsetHeight > 41 ? this.katexfield.offsetHeight : 41) + 4}px`,
      }
    })
    this.katexObserver.observe(this.katexfield)
  }

  private beforeDestroy() {
    this.textObserver.disconnect()
    this.katexObserver.disconnect()
  }

  private movefun(event: Event) {
    event.preventDefault()
  }
  private onResize() {
    this.innerWidth = window.innerWidth
    this.innerHeight = window.innerHeight
  }
  private async recognize() {
    await wait(500)

    if (this.strokes.length === 0) {
      this.resultHtml = ''
      this.resultLatex = ''
      return
    }

    const strokes: MyScriptStroke[] = this.strokes.map((stroke: Stroke[]) => ({
      x: stroke.map((t: Stroke) => t.x),
      y: stroke.map((t: Stroke) => t.y),
    }))

    this.myScript.setStrokes = await strokes
    this.myScript.setSize = await { width: this.width, height: this.height }
    await this.myScript.recognize()
    this.resultLatex = this.myScript.latex
    this.resultHtml = this.myScript.html
  }
  //
  // ツールボタンが押された時
  //
  public clear() {
    this.strokes = []
    this.resultLatex = ''
    this.recognize()
  }
  private complete(event: Event) {
    this.hide(event)
    this.$emit('input', this.resultLatex)
    this.$emit('set-stroke-data', this.strokes)
  }
  //
  // 手書きが止まった時の処理
  //
  private stopPen(strokes: Stroke[][]) {
    this.strokes = strokes
    this.recognize()
  }
  private stopEraser(strokes: Stroke[][]) {
    this.strokes = strokes
    this.recognize()
  }
  //
  // ダイアログの表示と非表示
  //
  private show(event: Event) {
    if (this.isShow) return
    let body = document.querySelector('body')
    if (body) {
      body.style.overflowX = 'hidden'
      body.style.overflowY = 'hidden'
    }
    this.isShow = true
    event.stopPropagation()
    window.addEventListener('touchmove', this.movefun, { passive: true })
    // const tegaki_footer = document.getElementsByClassName('tegaki')
    this.canvas.draw()
  }
  private async hide(event: Event) {
    let body = document.querySelector('body')
    if (body) {
      body.style.overflowX = 'auto'
      body.style.overflowY = 'auto'
    }
    await wait(100)
    this.isShow = false
    event.stopPropagation()
    window.removeEventListener('touchmove', this.movefun, false)
  }
}
